
import barba from '@barba/core';
import MicroModal from 'micromodal';
import PerfectScrollbar from 'perfect-scrollbar';

export default class{

	constructor(){
        this.modal = false
        this.options = {
            disableScroll:false,
            disableFocus:true,
            // openTrigger:"data-modal-trigger",
            // closeTrigger:"data-modal-close",
            awaitOpenAnimation: true, 
            awaitCloseAnimation: true,
            onShow :(modal) => {
                this.modal = modal
                const triggerButton = document.querySelector('[data-modal-trigger="' + this.modal.id + '"]')
                if(triggerButton){
                    triggerButton.setAttribute('aria-expanded','true')
                }
                if(this.modal.id == 'dropdown-1' || this.modal.id == 'dropdown-2'){
                    this.setLeft()
                    window.addEventListener('resize',this.setLeft.bind(this))
                    window.addEventListener('resize',this.closeDropDown.bind(this))

                    const container = modal.querySelector('.l-dropdown__content');
                    if(container){
                        this.ps = new PerfectScrollbar(container,{
                            wheelSpeed:1.5
                        });
                    }
                }
                if(this.modal.id == 'l-drawer'){
                    const drawerWrapper = document.querySelector('.l-drawer__wrapper')
                    if(drawerWrapper){
                        drawerWrapper.scrollTo(0,0)
                    }
                    window.addEventListener('resize',this.closeDrawer.bind(this))
                }
            },
            onClose: (modal) => {
                this.modal = modal
                const triggerButton = document.querySelector('[data-modal-trigger="' + this.modal.id + '"]')
                if(triggerButton){
                    triggerButton.setAttribute('aria-expanded','false')
                }
                if(this.modal.id == 'dropdown-1' || this.modal.id == 'dropdown-2'){
                    window.removeEventListener('resize',this.setLeft)
                    window.removeEventListener('resize',this.closeDropDown)
                }
                
                if(this.modal.id == 'l-drawer'){
                    window.removeEventListener('resize',this.closeDrawer)
                }
                if(this.ps){
                    this.ps.destroy();
                    this.ps = null;
                }
                this.modal = false
            }
        }
        

        barba.hooks.afterOnce((data) => {
            // this.MicroModal = new MicroModal()
        
            this.OpenTriggers = document.querySelectorAll('[data-modal-trigger]')
            if(this.OpenTriggers.length > 0){
                this.OpenTriggers.forEach(t => {
                    this._show(t)
                })
            }
            this.CloseTriggers = document.querySelectorAll('[data-modal-close]')
            if(this.CloseTriggers.length > 0){
                this.CloseTriggers.forEach(t => {
                    this._close(t)
                })
            }
        })
        // barba.hooks.leave((data) => {
        //     if(this.modal){
        //         MicroModal.close(this.modal.id)
        //     }
        // })
        barba.hooks.afterEnter((data) => {
        
            this.OpenTriggers = document.querySelectorAll('[data-modal-trigger]')
            if(this.OpenTriggers.length > 0){
                this.OpenTriggers.forEach(t => {
                    this._show(t)
                })
            }
            this.CloseTriggers = document.querySelectorAll('[data-modal-close]')
            if(this.CloseTriggers.length > 0){
                this.CloseTriggers.forEach(t => {
                    this._close(t)
                })
            }
        });
    }
    _show(t){
        t.addEventListener('click',(e) => {
            const id = t.getAttribute('data-modal-trigger')
            if(id == "l-drawer"){
                this.options.disableScroll = true
            }
            MicroModal.show(id,this.options)
        })
    }
    _close(t){
        t.addEventListener('click',(e) => {
            if(this.modal){
                MicroModal.close(this.modal.id)
            }
        })
    }
    setLeft (){
        if(this.modal){
            const closeButton = this.modal.querySelector('.l-dropdown__close--button')
            const triggerButton = document.querySelector('[data-modal-trigger="' + this.modal.id + '"]')
            let left =  (triggerButton.parentElement.getBoundingClientRect().left)
            // this.ua = window.navigator.userAgent.toLowerCase();
            // if(this.ua.indexOf("windows nt") !== -1) {
            //     const scrollbarWidth = window.innerWidth - document.body.clientWidth
            //     left = left - scrollbarWidth
            // }
            if(closeButton&&triggerButton){
                closeButton.style.left = left + 'px'
            }
        }
    }
    closeDropDown(){
        if(this.modal){
            if(this.modal.id == 'dropdown-1' || this.modal.id == 'dropdown-2'){
                if(document.documentElement.clientWidth <= 992){
                    MicroModal.close(this.modal.id)
                }
            }
        }
    }
    closeDrawer(){
        if(this.modal){
            if(this.modal.id == 'l-drawer'){
                if(document.documentElement.clientWidth >= 991){
                    MicroModal.close(this.modal.id)
                }
            }
        }
    }

}